export const CONTROLLED_DATE_TIME_PICKER_TYPES = {
  DATE_TIME: {
    FULL: 'full-date-time',
    CONTROLLER_ONLY: 'date-time-picker-controller-only',
    PICKER: 'date-time-picker',
    INPUTS: 'date-time-inputs',
  },
  DATE: {
    FULL: 'full-date',
    CONTROLLER_ONLY: 'date-picker-controller-only',
    PICKER: 'date-picker',
    INPUTS: 'date-inputs',
  },
  TIME: {
    FULL: 'full-time',
    CONTROLLER_ONLY: 'time-picker-controller-only',
    PICKER: 'time-picker',
    INPUTS: 'time-inputs',
  },
} as const;
